// Completed-answer playback has a bounded passage contract shared by HTTP and UI.
// Conservative parts leave room under Soniox's two-minute audio cap, including
// slow Swedish prose. Duration is still vendor-enforced: truncation is failure.
// The same partition is used by source admission and the player, for every engine.
export const READ_ALOUD_MAX_CHARS = 800;
export const READ_ALOUD_MAX_SSML_CHARS = 5800;
export const READ_ALOUD_STREAM_MS = 10 * 60_000;
// Ten minutes of mono 24 kHz PCM16 is 28.8 MB. The decoded browser queue stays 2 s.
export const READ_ALOUD_AUDIO_BYTES = 32 * 1024 * 1024;
export const SENTENCE_AUDIO_BYTES = 4 * 1024 * 1024;

export const isPassageSource = (source) =>
  source?.kind === 'stored_message' && source.format === 'passages';
export const audioByteLimit = (source) =>
  isPassageSource(source) ? READ_ALOUD_AUDIO_BYTES : SENTENCE_AUDIO_BYTES;
export const streamLifetime = (source, sentenceMs, passageMs = READ_ALOUD_STREAM_MS) =>
  isPassageSource(source) ? passageMs : sentenceMs;
